export default __webpack_public_path__ + "static/media/m.4daac440.jpeg";